import { createRatingTokens } from '../tokens/components.js';
import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * Rating Component Configuration
 */
export function createRating(s: SemanticTokens) {
  const ratingTokens = createRatingTokens(s);
  return {
      root: { gap: ratingTokens.base.gap, transitionDuration: ratingTokens.base.transition },
      icon: {
        size: ratingTokens.base.iconSize,
        color: ratingTokens.iconFg,
        hoverColor: ratingTokens.iconFgHover,
        activeColor: ratingTokens.iconFgActive,
      },
      css: () => `
        .p-rating.p-readonly .p-rating-option {
          cursor: default;
        }
      `,
      };
}
export const rating = createRating(SEMANTIC);